var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 24 24","fill":"none","stroke":_vm.color,"stroke-width":_vm.weight,"stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M18 6 6 18"}}),_c('path',{attrs:{"d":"m6 6 12 12"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }